var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: {
        "notifications-wrapper": true,
        "is-active": _vm.isActive,
      },
    },
    [
      _c(
        "button",
        {
          staticClass: "notification-btn",
          attrs: { type: "button", "aria-label": "Your Notifications" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              $event.stopPropagation()
              return _vm.toggleActive.apply(null, arguments)
            },
          },
        },
        [
          _c("SvgIcon", {
            attrs: {
              icon: "filled-notifications",
              classes: "notification-btn__icon",
              "is-filled": true,
            },
          }),
          _vm._v(" "),
          _vm.count > 0
            ? _c("span", {
                staticClass: "notification-btn__count",
                domProps: { textContent: _vm._s(`+${_vm.count}`) },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "notifications" },
        [
          _c("header", { staticClass: "notifications__header" }, [
            _c("h3", [_vm._v("Notifications")]),
            _vm._v(" "),
            _c(
              "a",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.notifications && _vm.notifications.length > 0,
                    expression: "notifications && notifications.length > 0",
                  },
                ],
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.handleClearAll.apply(null, arguments)
                  },
                },
              },
              [_vm._v("\n                Clear All\n            ")]
            ),
          ]),
          _vm._v(" "),
          _vm.$wait.is("get_notifications")
            ? _c(
                "div",
                { staticClass: "loading" },
                [_c("Spinner", { attrs: { height: 40, width: 40 } })],
                1
              )
            : _vm.notifications && _vm.notifications.length > 0
            ? [
                _c(
                  "ul",
                  { staticClass: "notifications-list" },
                  _vm._l(_vm.notifications, function (notification) {
                    return _c(
                      "li",
                      { class: { "is-read": notification.read } },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "notification-detail",
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                $event.stopPropagation()
                                return _vm.handleNotificationClicked(
                                  notification
                                )
                              },
                            },
                          },
                          [
                            _c("span", {
                              staticClass: "notification-detail__message",
                              domProps: {
                                innerHTML: _vm._s(notification.message),
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "notification-detail__avatars" },
                              _vm._l(
                                notification.related_users.slice(0, 3),
                                function (user) {
                                  return _c("img", {
                                    attrs: {
                                      src: user.avatar
                                        ? user.avatar.url
                                        : "//placehold.it/32x32",
                                      alt: `Profile Image for ${user.name}`,
                                    },
                                  })
                                }
                              ),
                              0
                            ),
                            _vm._v(" "),
                            _c("span", {
                              staticClass: "notification-detail__date",
                              domProps: {
                                textContent: _vm._s(
                                  notification.date_formatted
                                ),
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "clear-notification",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                $event.stopPropagation()
                                return _vm.handleClear(notification.id)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        ✕\n                    "
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "notifications__all",
                    attrs: { to: { name: "view-notifications" } },
                  },
                  [_vm._v("\n                View All\n            ")]
                ),
              ]
            : _c("div", { staticClass: "no-results" }, [
                _c("span", [_vm._v("You're all caught up!")]),
              ]),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }